import axios from 'axios';
import VueI18n from 'vue-i18n';
import { Store } from 'vuex';

export default class TranslationService {
  private store: Store<{}>;
  private i18n: VueI18n;

  constructor(store: Store<{}>, i18n: VueI18n) {
    this.store = store;
    this.i18n = i18n;
  }

  public refreshTranslation(newLanguage: string) {
    let currentLanguage = this.store.getters.currentLanguage;
    currentLanguage = newLanguage ? newLanguage : 'it';
    if (this.i18n && !this.i18n.messages[currentLanguage]) {
      var today = new Date();
      var dd = String(today.getDate());
      while (dd.length < 2) dd = '0' + dd;

      var mm = String(today.getMonth() + 1);
      while (mm.length < 2) mm = '0' + mm;
      var yyyy = today.getFullYear();
      var hh = today.getHours();
      var dateStr = yyyy + mm + dd + hh;

      this.i18n.setLocaleMessage(currentLanguage, {});
      axios.get('i18n/' + currentLanguage + '.json?v=001' + dateStr).then(res => {
        if (res.data) {
          this.i18n.setLocaleMessage(currentLanguage, res.data);
          this.i18n.locale = currentLanguage;
          this.store.commit('currentLanguage', currentLanguage);
        }
      });
    } else if (this.i18n) {
      this.i18n.locale = currentLanguage;
      this.store.commit('currentLanguage', currentLanguage);
    }
  }
}
